import type { StatusTone } from '../../../../components/Tone';
import type { CoverStatus } from '../../cover-dates';

/** One tone per status, the same on the timeline's bars and the list's chips (ADR 0035). */
export function coverTone(status: CoverStatus): StatusTone {
  if (status === 'active') return 'live';
  if (status === 'scheduled') return 'new';
  return 'ended';
}
